import React from 'react';
import {Waypoint} from 'react-waypoint';
import {LoadingSpinner} from 'components/Loading';
import classNames from 'classnames';

const defaultProps = {
  className: 'mt-5',
};

function Component(props) {
  const {isLoading, hasMore, loadMore, className} = props;

  function handleEnter({currentPosition, previousPosition}) {
    if (currentPosition === 'inside' && previousPosition === 'below') {
      return loadMore();
    }
  }

  if (isLoading)
    return (
      <div className={classNames('text-center', className)}>
        <LoadingSpinner />
      </div>
    );

  if (hasMore) {
    return (
      <Waypoint onEnter={handleEnter}>
        <div className={classNames('text-center', className)}>
          <LoadingSpinner />
        </div>
      </Waypoint>
    );
  } else {
    return <div />;
  }
}

Component.defaultProps = defaultProps;

export default Component;
